<template>
  <!-- <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in"> -->
        <v-container fluid class="pa-3">

          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>Email Invitation</v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn class="primary" small fab :href="'req_log?uuid=17039181-95cf-4351-9100-9758cdd16d0f&Lev=email&Lso=' + selected._id" v-on="on">
                          <v-icon>format_list_bulleted</v-icon> 
                        </v-btn>
                      </template>
                      <span>Email Log</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-title class="headline pb-0"></v-card-title>

                <v-card-text>
                  <v-form ref="MainForm">
                    <!-- <v-container grid-list-md class="pa-0"> -->
                      <v-layout row wrap>
                        <v-flex pa-2 class="dull">
                          
                          <v-container grid-list-md class="pa-2">
                            <v-layout row wrap>

                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.from"
                                  label="From"
                                ></v-text-field>
                              </v-flex>                        
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.to?selected.to.join('; '):''"
                                  label="To"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.cc"
                                  label="Cc"
																	v-show="false"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.bcc"
                                  label="Bcc"
																	v-show="false"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.subject"
                                  label="Subject"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                  readonly
                                  :value="selected.body"
                                  label="Body"
																	v-show="false"
                                ></v-text-field>
                              </v-flex>
															<v-flex xs12>
																<div id="idBody"></div>
															</v-flex>
                            
                            </v-layout>
                          </v-container>
                        </v-flex>

                      </v-layout>
                    <!-- </v-container> -->
                  </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="orange" flat :href="'req_applicants_crud?uuid=4fa09d2a-b89e-463e-9416-6c99118712c6&email_invi=1&_id=' + selected._id + '&reqid=' + selected.req_id">
                      Cancel
                    </v-btn>
                    <v-btn color="blue" flat @click="sendEmail_onclick()">
                      Email Now
                    </v-btn>
                </v-card-actions>

              </v-card>
            </v-flex>
          </v-layout>

        </v-container>
      <!-- </v-slide-y-transition>

    </v-flex>
  </v-layout> -->

</template>

<script>
// import axios from "axios";
import auth from "../../functions/auth";
import common from "../../functions/general";

export default {
  name: "req_email_invi",
  // components: {
  //   PageLayout: PageLayout,
  // },
  data() {
    return {
      username: "",
      // qStr_reqid: "",
      showMenu: false,
      filters_setting: {
        filter_row: 0,
      },
      rules: {
        required: (value) => !!value || "This field required.",
        greater_than_zero: (value) => value > 0 || "Value must greater than 0.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'},
          },
      // status_option: [],
      selected: {}
    };
  },
  computed: {
  },
  watch: {
  },
  async mounted() {
    common.App.set_page_title("mySuite: Req Email");

    this.username = auth.getUsername();
		this.refreshData();
  },
  created (){
    auth.hideHeader(false);
  },
  methods: {
    epoch2localedatetime: common.App.epoch2LocaleDatetime,
    async refreshData() {
      common.App.loader.show(this);

      let obj = {
        "_id": common.App.getQueryString("_id"),
        "url_base": window.location.protocol + "//" + window.location.host
      }

			var res = await common.wBackEndComm.PostData("mycareer/requisition_email_compose/", obj);
			res = res.data;
			if (res.Status == 1) {
				this.selected = res.Body;
        document.getElementById("idBody").innerHTML = this.selected.body;
			} else {
				common.wMsgBox.Error(res.Description);
			}
      common.App.loader.hide(this);
    },
    async sendEmail_onclick() {
      common.App.loader.show(this);

      let obj = {
        "_id": common.App.getQueryString("_id"),
        "url_base": window.location.protocol + "//" + window.location.host
      }

      var res = await common.wBackEndComm.PostData("mycareer/requisition_email_send/", obj);
			res = res.data;
			if (res.Status == 1) {
        common.wMsgBox.Success(res.Description);
        window.location.href = "req_applicants_crud?uuid=4fa09d2a-b89e-463e-9416-6c99118712c6&email_invi=1&_id=" + this.selected._id + "&reqid=" + this.selected.req_id;
			} else {
				common.wMsgBox.Error(res.Description);
			}
      common.App.loader.hide(this);
    }
  }
};
</script>

<style>

</style>
  